"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const translations_1 = __importStar(require("./translations"));
class CommonTranslationBackend {
    constructor() {
        this.namespacePrefix = "";
    }
    init(_services, backendOptions, _i18nextOptions) {
        console.debug("init CommonTranslationBackend, active for", translations_1.languageCodes);
        backendOptions.lngs = translations_1.languageCodes;
        console.log("CommonTranslationBackend opts", backendOptions);
        backendOptions.ns = translations_1.namespaces.map((ns) => {
            if (backendOptions.namespacePrefix) {
                return `${backendOptions.namespacePrefix}:${ns}`;
            }
            return ns;
        });
        if (backendOptions.namespacePrefix) {
            backendOptions.ns.push(backendOptions.namespacePrefix);
            this.namespacePrefix = backendOptions.namespacePrefix;
        }
    }
    read(language, namespace, callback) {
        console.debug("CommonTranslationBackend", {
            language: language.toLowerCase(),
            namespace,
        });
        try {
            const forLanguage = translations_1.default[language.toLowerCase()];
            if (!forLanguage) {
                console.debug("CommonTranslationBackend: no translations for", language, translations_1.default);
                callback({ name: "error", message: "missing translations" }, null);
                return;
            }
            if (namespace === this.namespacePrefix) {
                console.debug("CommonTranslationBackend: found for namespace (prefix)");
                callback(null, forLanguage);
                return;
            }
            if (namespace.includes(":")) {
                console.debug("CommonTranslationBackend: found for namespace (prefix)");
                callback(null, forLanguage[namespace.replace(`${this.namespacePrefix}:`, "")]);
                return;
            }
            if (namespace) {
                console.debug("CommonTranslationBackend: found for namespace");
                callback(null, forLanguage[namespace]);
                return;
            }
            console.debug("CommonTranslationBackend: found for language");
            callback(null, forLanguage);
            return;
        }
        catch (err) {
            console.error(err);
            console.debug("CommonTranslationBackend: error", err);
            callback({ name: "error", message: "missing translations" }, null);
        }
    }
}
exports.default = CommonTranslationBackend;
